import { getEmployeeIdSelector } from 'omniplatform/employee/store/selectors/employee.selector';
import { useSelector } from 'react-redux';

export const useSelectEmployeeId = () =>
  useSelector<unknown, string>(getEmployeeIdSelector);
